import { observer } from 'mobx-react-lite';

import { GeoLoadRigOperation } from '../../entities/geological-load/geo-load-rig-operation.entity';
import { GeoLoadSection } from '../../entities/geological-load/geo-load-section.entity';
import { GeoLoadStage } from '../../entities/geological-load/geo-load-stage.entity';
import { GeologicalLoadValidation } from '../../entities/geological-load/geological-load-validation';
import { RigOperation } from '../../entities/rig-operations/rig-operation.entity';
import { GeologicalItem } from '../geological-load-item';
import { GeologicalLoadStage } from '../geological-load-stage';
import { GeologicalLoadViewModel } from '../geological-load-view-model';

import styles from './geological-load-rig-operation.module.scss';

type Props = {
  geoLoadRigOperation: GeoLoadRigOperation;
  rigOperation: RigOperation;
  viewModel: GeologicalLoadViewModel;
  validation: GeologicalLoadValidation;
  onValueChange(
    fieldId: string,
    value: unknown,
    {
      geoLoadRigOperation,
      geoLoadStage,
      geoLoadSection,
    }: {
      geoLoadRigOperation: GeoLoadRigOperation;
      geoLoadStage?: GeoLoadStage;
      geoLoadSection?: GeoLoadSection;
    },
  ): void;
};

export const GeologicalLoadRigOperation = observer<Props>(function GeologicalLoadRigOperation({
  geoLoadRigOperation,
  rigOperation,
  viewModel,
  validation,
  onValueChange,
}) {
  const { stages: geoLoadStages, geologicalLoad } = geoLoadRigOperation;

  if (!geoLoadStages.length) {
    return (
      <GeologicalItem
        geologicalLoad={geologicalLoad}
        viewModel={viewModel}
        validation={validation}
        onValueChange={(fieldId, value) => onValueChange(fieldId, value, { geoLoadRigOperation })}
      />
    );
  }

  return (
    <div className={styles.wrapper}>
      {geoLoadStages.map((geoLoadStage) => {
        const stage = rigOperation.stages.find((stage) => geoLoadStage.stageEntityId === stage.entityId);

        if (!stage) {
          console.error('cannot find corresponding stage', geoLoadStage);
          return null;
        }

        return (
          <GeologicalLoadStage
            key={geoLoadStage.entityId}
            geoLoadStage={geoLoadStage}
            stage={stage}
            viewModel={viewModel}
            validation={validation}
            onValueChange={(fieldId, value, geoLoadStage, geoLoadSection) => {
              onValueChange(fieldId, value, { geoLoadRigOperation, geoLoadStage, geoLoadSection });
            }}
          />
        );
      })}
    </div>
  );
});
